import BrandLogo from '../Brand/BrandLogo';
import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ArrowUpRight, Globe2, Menu, X } from 'lucide-react';
import { isLanguage, languages, useI18n } from '../../i18n/LanguageContext';

export default function Header() {
  const { language, setLanguage, t } = useI18n();
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname, hash]);
  useEffect(() => {
    const close = (event: KeyboardEvent) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);
  return <header className="header"><div className="headerInner">
    <Link className="brand" to="/" aria-label={t('TronicsBase home')}><BrandLogo/></Link>
    <nav id="navigation" className={`navigation ${open ? 'isOpen' : ''}`} aria-label={t('Main navigation')}>
      <NavLink to="/" end>{t('The app')}</NavLink><Link to="/#app-tour">{t('Features')}</Link><NavLink to="/products">{t('Components')}</NavLink><NavLink to="/kits">{t('Kit Hub')}</NavLink><NavLink to="/competitions">{t("Competition")}</NavLink><NavLink to="/services">{t('Services')}</NavLink><NavLink to="/about">{t('About us')}</NavLink>
      <NavLink className="button primary navCta" to="/downloads">{t('Get the app')} <ArrowUpRight size={16}/></NavLink>
      <NavLink className="button navContact" to="/contact">{t('Contact us')}</NavLink>
    </nav>
    <div className="headerControls">
      <label className="languagePicker"><Globe2 size={16} aria-hidden="true"/><span className="srOnly">{t('Language')}</span>
        <select value={language} onChange={event => { if (isLanguage(event.target.value)) setLanguage(event.target.value); }}>
          {languages.map(({code,name}) => <option key={code} value={code} lang={code}>{name}</option>)}
        </select>
      </label>
      <button className="menuToggle" aria-label={t(open ? 'Close navigation' : 'Open navigation')} aria-expanded={open} aria-controls="navigation" onClick={() => setOpen(!open)}>{open ? <X/> : <Menu/>}</button>
    </div>
  </div></header>;
}
